<div class="auth-header">
    @if (!loginViaOtp) {
    <span>ENTER PASSWORD</span>
    }
    @if (loginViaOtp) {
    <span>ENTER OTP</span>
    }
</div>

<div mat-dialog-content class="form-fields-theme">
    <form name="signinForm" [formGroup]="signinForm" (submit)="signIn()">
        <mat-form-field>
            <mat-label>Phone Number</mat-label>
            <input matInput formControlName="mobile" type="text"/>
        </mat-form-field>
        <mat-form-field>
            <mat-label>{{ loginViaOtp ? 'OTP' : 'Password' }}</mat-label>
            <input matInput data-test="password-input" formControlName="password"
                type="{{ loginViaOtp ? 'text' : 'password' }}"
                required />
            @if (signinForm.get('password').hasError('minlength') || signinForm.get('password').hasError('required')) {
            <mat-error>
                Please enter valid password / OTP.
            </mat-error>
            }
        </mat-form-field>
        <input type="submit" style="position: absolute; left: -9999px" />
    </form>
</div>

@if (loginViaOtp) {
@if (!enableResendOtp) {
<div class="content-wrapper">
    <span class="resend-otp">
        Resend OTP in
        <b style="color: inherit">00:{{ timeDelay }}</b>
    </span>
</div>
}
@if (enableResendOtp) {
<div class="content-wrapper">
    <span class="resend-otp">Resend OTP via</span> <br />
    <div class="resend-otp-wrapper">
        <button (click)="loginWithOtp(true, 'otp')" class="resend-cta center">
            <img style="margin-right: 5px" src="{{ DEPLOY_URL }}/assets/images/sms_teal.svg" />
            SMS
        </button>
        <button (click)="loginWithOtp(true, 'whatsapp_otp')" class="resend-cta center">
            <img style="margin-right: 5px" src="{{ DEPLOY_URL }}/assets/images/whatsapp_teal.svg" />
            WhatsApp
        </button>
    </div>
</div>
}
}

<div class="row">
    <div class="col-sm-12 col-md-12 col-lg-12 option-container">
        @if (!loginViaOtp) {
        <div class="forgot-password" (click)="initiateResetPassword()">Forgot Password?</div>
        }
        <div class="login-with" [ngStyle]="{ width: loginWithOtp ? '100%' : '50%' }">
            Login with
            @if (!loginViaOtp) {
            <span (click)="loginWithOtp(true, 'otp')">OTP</span>
            }
            @if (loginViaOtp) {
            <span (click)="loginWithOtp(false)">Password</span>
            }
        </div>
    </div>
</div>

<div class="clearfix"></div>

<div class="row">
    <div class="col-sm-12 mb-10">
        <button btn-primary size="full" (click)="signIn()" [isLoading]="btnLoading">SUBMIT</button>
    </div>
</div>